import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import MoveMoneyPayeeStore from '../../stores/MoveMoneyPayeeStore';
import InternetBankingActions from '../../actions/InternetBankingActions';
import MoveMoneyPayeeActionCreator from '../../actions/MoveMoneyPayeeActionCreator';
import SvgIcon from '../common/SvgIcon';
import NumberUtils from '../../utils/NumberUtils';
import StepHeader from '../../includes/StepHeader';
import { sayMessage } from '../../actions/AccessibilityActionCreator';

class EditPayeeSummary extends Component {
  constructor(props) {
    super(props);
    this.showPayeePage = this.showPayeePage.bind(this);
    this.goToMoveMoneyPage = this.goToMoveMoneyPage.bind(this);
    this.goToManagePayee = this.goToManagePayee.bind(this);
    this.getSortCodeDisplayNumber = this.getSortCodeDisplayNumber.bind(this);
    this.state = {
      allPayeeCardInfo: true,
      editPayeePageFlag: false,
      showEditPayeeSummaryPage: false,
    };
  }

  componentDidMount() {
    sayMessage(this.props.content.editpayeeSumamaryMsg);

    window.scrollTo(0, 0);
  }

  getSortCodeDisplayNumber() {
    let sortcode = _.split(MoveMoneyPayeeStore.nameUpdate().sort_code, '-');
    sortcode = NumberUtils.formatSortCode(sortcode[0]);
    return sortcode;
  }

  goToAccounts() {
    // const fromSelectedAccount = MoveMoneyStore.getSelectedAccount();
    MoveMoneyPayeeActionCreator.resetData();
    // AccountsActionCreator.getAccountsList();
    InternetBankingActions.navigateToWebTask('WEB-HOMEPAGE');
  }

  goToManagePayee() {
    //  MoveMoneyPayeeStore.resetFlags();
    MoveMoneyPayeeActionCreator.resetData();
    // MoveMoneyPayeeStore.resetStore();
    this.props.goToManagePayee();
  }

  goToMoveMoneyPage() {
    MoveMoneyStore.resetAfterEditPayment();
    MoveMoneyStore.makePaymentToThisPayee();
    this.props.goToMoveMoneyPage(MoveMoneyPayeeStore.nameUpdate());
  }

  showPayeePage() {
    // call parent method to update flag to call Payee component condition
    this.props.showPayees();
    this.setState({
      allPayeeCardInfo: false,
    });
  }

  render() {
    let renderContent;
    let displayName = '-';
    if (MoveMoneyPayeeStore.nameUpdate().display_name === '') {
      displayName = '-';
    } else displayName = MoveMoneyPayeeStore.nameUpdate().display_name;
    renderContent = (
      <div className="payee-updated" id="site-main" tabIndex="-1">
        <StepHeader
          showheaderCrumbs={false}
          headerTitle={this.props.content.editpayeeSumamaryMsg}
        />
        <div className="c-media">
          <div className="c-media__thumb">
            <SvgIcon id="icon-success" width="64px" height="64px" />
          </div>
          <div className="c-media__body">
            <p>
              The details for{' '}
              <span
                className="word-break-all"
                data-test-id="payee-updated-heading-name"
              >
                {MoveMoneyPayeeStore.nameUpdate().name}
              </span>{' '}
              have now been updated.
            </p>
          </div>
        </div>
        <div className="row">
          <div className="col-md1-18">
            <dl className="c-definitions">
              <dt className="c-definitions__key">Name</dt>
              <dd
                className="c-definitions__value"
                data-test-id="payee-updated-table-name"
              >
                {MoveMoneyPayeeStore.nameUpdate().name}
              </dd>

              <dt className="c-definitions__key">Nickname</dt>
              <dd className="c-definitions__value">{displayName}</dd>

              <dt className="c-definitions__key">Sortcode</dt>
              <dd className="c-definitions__value">
                {this.getSortCodeDisplayNumber()}
              </dd>

              <dt className="c-definitions__key">Account number</dt>
              <dd className="c-definitions__value">
                {MoveMoneyPayeeStore.nameUpdate().account_number}
              </dd>

              <dt className="c-definitions__key">Reference</dt>
              <dd className="c-definitions__value">
                {MoveMoneyPayeeStore.nameUpdate().reference}
              </dd>
            </dl>
          </div>
        </div>
        <br />
        <div className="payee-updated__options">
          <button
            type="button"
            className="c-btn c-btn--default"
            onClick={this.goToMoveMoneyPage}
          >
            Now make a payment to them
          </button>
          &nbsp;
          <br />
          <br />
          <button
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToAccounts}
          >
            Go to your accounts
          </button>
          &nbsp;
          <button
            type="button"
            className="c-btn c-btn--secondary"
            onClick={this.goToManagePayee}
          >
            {this.props.content.quikLinkMsg}
          </button>
          &nbsp;
        </div>
      </div>
    );

    return <div>{renderContent}</div>;
  }
}

EditPayeeSummary.propTypes = {
  content: PropTypes.object,
  showPayees: PropTypes.func,
  goToManagePayees: PropTypes.func,
  goToMoveMoneyPage: PropTypes.func,
};
EditPayeeSummary.defaultProps = {
  content: {},
};

export default EditPayeeSummary;
